<template>
  <div :class="[isNewUiEnabled ? 'flex gap-1.5 items-center' : 'contents']">
    <i v-if="isNewUiEnabled" class="fas fa-x text-new-red-600 text-new-sm ml-new-sm" />
    <span class="text-base" :class="[isNewUiEnabled ? 'text-new-red-600' : 'text-lightred']">{{ message }}</span>
  </div>
</template>

<script setup lang="ts">
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

interface Props {
  message: string
}

defineProps<Props>()

const isNewUiEnabled = useNewUiEnabled()
</script>
